import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as actions from '@app/actions/index';
import * as models from '@app/models/index';
import SigninComponent from './signin.component';

function mapStateToProps(state: models.IAuthState): models.IAuthState {
	return {
		...state,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): models.ISignInComponentProps {
	return {
		intl: null,
		openSnackBar: null,
		onUserSignIn: (state) => dispatch(actions.userSignedInAction(state)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SigninComponent);



// WEBPACK FOOTER //
// ./src/components/account/signin/signin.ts